import React from "react";
import "./style.scss";
import Calculator from "./components/Calculator";
function App() {
  return (
    <div className="App">
      <h1>MightyCal</h1>
      <Calculator />
    </div>
  );
}

export default App;
